import { metadata, withMetadata } from "../common/mod.js";
export function documented(docs, inner) {
    return withMetadata(metadata("$.documented", documented, docs, inner), inner);
}
//# sourceMappingURL=documented.js.map